export const COMPANY = {
  name: "Perspective Assurance",
  phone: "+33782758870",
  phoneDisplay: "+33 7 82 75 88 70",
  email: "julien.maertens@perspective-assurance.fr",
  address: "16 Rue Cuvier, 69006 Lyon",
  whatsapp: "https://api.whatsapp.com/send?phone=%2B33782758870",
  instagram: "https://instagram.com/perspective_assurance",
  maps: "https://maps.google.com/maps?q=16%20RUE%20CUVIER%2C%20Lyon",
};

export const SERVICES = [
  {
    slug: "assurance-decennale",
    title: "Assurance Décennale",
    short: "Garantie obligatoire 10 ans pour les professionnels du bâtiment.",
    icon: "HardHat",
    image: "https://images.pexels.com/photos/37556458/pexels-photo-37556458.jpeg",
    metaTitle: "Assurance Décennale Lyon — Devis Garantie 10 ans BTP | Perspective Assurance",
    metaDescription: "Assurance décennale obligatoire pour artisans et entreprises du bâtiment. Couverture sur mesure, devis rapide, accompagnement complet. Courtier à Lyon.",
    hero: {
      eyebrow: "Garantie obligatoire BTP",
      title: "Assurance Décennale",
      subtitle: "Protégez votre activité de bâtiment avec une couverture sur mesure, valable 10 ans après la réception de vos travaux."
    },
    benefits: [
      { title: "Conforme à la loi Spinetta", text: "Respect strict des obligations légales pour tous les professionnels du BTP intervenant sur du gros œuvre." },
      { title: "Couverture 10 ans", text: "Protection contre les dommages compromettant la solidité de l'ouvrage ou le rendant impropre à sa destination." },
      { title: "Attestation rapide", text: "Délivrance d'une attestation conforme dès la signature, indispensable avant tout chantier." },
      { title: "Tarifs négociés", text: "Notre réseau de compagnies partenaires nous permet d'obtenir le meilleur rapport garanties/prix pour votre métier." }
    ],
    coversTitle: "Ce que couvre l'assurance décennale",
    covers: [
      "Fissures importantes affectant la structure",
      "Affaissements de planchers ou de toitures",
      "Infiltrations d'eau rendant le bâtiment inhabitable",
      "Défauts d'étanchéité majeurs",
      "Désordres compromettant la solidité de l'ouvrage",
      "Vices cachés rendant l'ouvrage impropre à sa destination"
    ],
    audience: "Artisans, auto-entrepreneurs, TPE/PME du bâtiment, maîtres d'œuvre, entreprises générales : maçons, plaquistes, électriciens, plombiers, charpentiers, couvreurs, carreleurs, peintres, paysagistes, terrassiers…",
    faq: [
      { q: "L'assurance décennale est-elle obligatoire ?", a: "Oui. La loi Spinetta de 1978 impose à tout professionnel du bâtiment de souscrire une assurance décennale avant l'ouverture de chaque chantier, sous peine de sanctions pénales et civiles." },
      { q: "Quand intervient la garantie ?", a: "La garantie démarre à la réception des travaux et court pendant 10 ans. Elle peut être déclenchée par le maître d'ouvrage en cas de désordre majeur, sans attendre de jugement." },
      { q: "Que se passe-t-il si je change d'activité ?", a: "Vous devez signaler tout changement d'activité ou d'extension de garantie à votre assureur. Nous nous chargeons de l'adapter rapidement à vos nouveaux chantiers." },
      { q: "Quel délai pour obtenir une attestation ?", a: "Sous 24 à 48h après validation de votre dossier, nous vous transmettons votre attestation officielle, indispensable pour démarrer vos chantiers." }
    ]
  },
  {
    slug: "mutuelle-sante",
    title: "Mutuelle Santé",
    short: "Complémentaire santé pour particuliers, familles et professionnels.",
    icon: "HeartPulse",
    image: "https://images.pexels.com/photos/30660778/pexels-photo-30660778.jpeg",
    metaTitle: "Mutuelle Santé Lyon — Complémentaire santé sur mesure | Perspective Assurance",
    metaDescription: "Mutuelle santé adaptée à votre profil : famille, TNS, retraité, salarié. Remboursements optimisés, devis gratuit et accompagnement personnalisé à Lyon.",
    hero: {
      eyebrow: "Santé & bien-être",
      title: "Mutuelle Santé",
      subtitle: "Une complémentaire santé taillée pour vos besoins réels : optique, dentaire, hospitalisation, médecines douces."
    },
    benefits: [
      { title: "Sur mesure", text: "Niveaux de garanties adaptés à votre âge, votre profil et votre budget — sans payer pour ce dont vous n'avez pas besoin." },
      { title: "100% Santé inclus", text: "Reste à charge zéro sur les paniers optique, dentaire et auditif conformément à la réforme." },
      { title: "Tiers payant", text: "Pas d'avance de frais chez la plupart des praticiens et pharmaciens partenaires." },
      { title: "Souplesse", text: "Possibilité de moduler vos garanties en cours de contrat selon vos besoins de vie." }
    ],
    coversTitle: "Postes de soins couverts",
    covers: [
      "Hospitalisation (chambre particulière, dépassements d'honoraires)",
      "Optique (lunettes, lentilles, chirurgie réfractive)",
      "Dentaire (prothèses, orthodontie, implants)",
      "Médecines douces (ostéopathie, acupuncture, naturopathie)",
      "Maternité et forfaits naissance",
      "Téléconsultation 7j/7"
    ],
    audience: "Particuliers, familles, travailleurs non salariés (TNS - loi Madelin), retraités, étudiants, expatriés et professions libérales souhaitant une couverture optimale sans surpayer.",
    faq: [
      { q: "Quelle différence entre Sécurité sociale et mutuelle ?", a: "La Sécurité sociale rembourse une partie des soins selon des bases conventionnelles. La mutuelle (ou complémentaire santé) prend en charge tout ou partie du reste à charge : ticket modérateur, dépassements d'honoraires, forfaits hospitaliers." },
      { q: "Puis-je changer de mutuelle à tout moment ?", a: "Oui, après un an d'engagement, vous pouvez résilier votre mutuelle à tout moment grâce à la loi de résiliation infra-annuelle. Nous nous occupons des démarches pour vous." },
      { q: "Existe-t-il une mutuelle adaptée aux TNS ?", a: "Oui, la mutuelle TNS (loi Madelin) permet aux indépendants de déduire les cotisations de leur revenu imposable, dans la limite des plafonds en vigueur." },
      { q: "Puis-je inclure mes enfants ?", a: "Absolument. Les contrats famille couvrent le conjoint et les enfants à charge, souvent à des conditions avantageuses." }
    ]
  },
  {
    slug: "prevoyance",
    title: "Prévoyance",
    short: "Protection financière en cas d'arrêt de travail, invalidité ou décès.",
    icon: "ShieldCheck",
    image: "https://images.pexels.com/photos/5816300/pexels-photo-5816300.jpeg",
    metaTitle: "Assurance Prévoyance Lyon — Protection arrêt travail, invalidité, décès | Perspective Assurance",
    metaDescription: "Contrat de prévoyance pour préserver vos revenus en cas d'incapacité, d'invalidité ou de décès. Solutions sur mesure pour TNS, salariés et chefs d'entreprise.",
    hero: {
      eyebrow: "Sécurité financière",
      title: "Prévoyance",
      subtitle: "Maintenez vos revenus et protégez vos proches face aux aléas de la vie : maladie, accident, invalidité, décès."
    },
    benefits: [
      { title: "Maintien de revenus", text: "Indemnités journalières en cas d'arrêt de travail pour préserver votre niveau de vie." },
      { title: "Capital décès", text: "Versement d'un capital à vos bénéficiaires pour les protéger financièrement." },
      { title: "Rente invalidité", text: "Compensation à long terme en cas d'invalidité partielle ou totale, professionnelle ou fonctionnelle." },
      { title: "Fiscalité Madelin", text: "Cotisations déductibles du revenu imposable pour les TNS (sous conditions)." }
    ],
    coversTitle: "Garanties incluses",
    covers: [
      "Incapacité temporaire de travail (ITT)",
      "Invalidité permanente partielle ou totale (IPP / IPT)",
      "Décès toutes causes (capital + rente conjoint)",
      "Rente éducation pour les enfants",
      "Frais d'obsèques",
      "Maintien des charges professionnelles (TNS)"
    ],
    audience: "Travailleurs non salariés, chefs d'entreprise, professions libérales, salariés cadres et non-cadres souhaitant compléter les indemnités de la Sécurité sociale ou prévoir l'imprévisible.",
    faq: [
      { q: "Pourquoi souscrire une prévoyance quand on est TNS ?", a: "Les indemnités de la Sécurité sociale des indépendants sont très limitées (parfois 0€ les premiers jours). Une prévoyance Madelin compense vos revenus dès le premier jour d'arrêt et protège votre famille." },
      { q: "Quelle différence avec l'assurance vie ?", a: "L'assurance vie est un produit d'épargne, la prévoyance est une assurance pure : elle verse un capital ou une rente uniquement si un sinistre survient (incapacité, invalidité, décès)." },
      { q: "Les cotisations sont-elles déductibles ?", a: "Pour les TNS dans le cadre de la loi Madelin, oui — les cotisations sont déductibles du bénéfice imposable dans la limite d'un plafond." },
      { q: "Y a-t-il un questionnaire médical ?", a: "Selon le niveau de garantie et votre âge, un questionnaire médical peut être demandé. Nous vous accompagnons pour le remplir et obtenir la meilleure tarification." }
    ]
  },
  {
    slug: "assurance-vie",
    title: "Assurance Vie",
    short: "Épargne souple, fiscalité avantageuse, transmission optimisée.",
    icon: "Sprout",
    image: "https://images.pexels.com/photos/30660778/pexels-photo-30660778.jpeg",
    metaTitle: "Assurance Vie Lyon — Placement épargne fiscalité avantageuse | Perspective Assurance",
    metaDescription: "Ouvrez ou transférez votre assurance vie avec un courtier indépendant à Lyon. Fonds euros, unités de compte, gestion pilotée. Optimisez épargne et transmission.",
    hero: {
      eyebrow: "Épargne & patrimoine",
      title: "Assurance Vie",
      subtitle: "Le placement préféré des Français : souple, fiscalement avantageux, idéal pour valoriser votre épargne et préparer la transmission."
    },
    benefits: [
      { title: "Disponibilité", text: "Votre épargne reste disponible à tout moment, sans pénalité ni blocage successoral." },
      { title: "Fiscalité douce", text: "Après 8 ans, abattement annuel sur les gains de 4 600€ (célibataire) ou 9 200€ (couple)." },
      { title: "Transmission", text: "Jusqu'à 152 500€ par bénéficiaire transmis hors succession (versements avant 70 ans)." },
      { title: "Multi-supports", text: "Combinez sécurité (fonds €) et performance (unités de compte, SCPI, ETF, immobilier) selon votre profil." }
    ],
    coversTitle: "Supports d'investissement",
    covers: [
      "Fonds en euros à capital garanti",
      "Unités de compte diversifiées (actions, obligations, ETF)",
      "SCPI et immobilier coté",
      "Gestion pilotée par horizon ou par profil de risque",
      "Mandats d'arbitrage automatiques",
      "ISR / ESG pour investir responsable"
    ],
    audience: "Particuliers souhaitant épargner à moyen ou long terme, préparer un projet (achat immobilier, études des enfants), constituer un complément de retraite, ou organiser la transmission de leur patrimoine.",
    faq: [
      { q: "Quel montant pour ouvrir une assurance vie ?", a: "Selon les contrats, les versements initiaux démarrent à partir de 100€. Vous pouvez ensuite alimenter le contrat librement ou par versements programmés." },
      { q: "Quelle différence avec un Livret A ?", a: "L'assurance vie offre potentiellement plus de rendement (notamment en unités de compte), des avantages fiscaux après 8 ans, et un cadre privilégié pour la transmission. Le Livret A est plafonné et 100% liquide mais peu rémunéré." },
      { q: "Que se passe-t-il en cas de décès ?", a: "Le capital est transmis hors succession aux bénéficiaires désignés, avec un abattement de 152 500€ par bénéficiaire (versements avant 70 ans), sous fiscalité avantageuse." },
      { q: "Puis-je retirer mon argent à tout moment ?", a: "Oui, l'épargne reste disponible. Les retraits (rachats) sont possibles à tout moment ; après 8 ans la fiscalité devient particulièrement douce." }
    ]
  },
  {
    slug: "plan-epargne-retraite",
    title: "Plan d'Épargne Retraite (PER)",
    short: "Préparez votre retraite tout en réduisant votre impôt.",
    icon: "Landmark",
    image: "https://images.pexels.com/photos/8791189/pexels-photo-8791189.jpeg",
    metaTitle: "Plan d'Épargne Retraite (PER) Lyon — Réduction impôt & retraite | Perspective Assurance",
    metaDescription: "Ouvrez un PER pour préparer votre retraite et déduire vos versements de votre revenu imposable. Sortie en capital ou rente, accompagnement par un courtier à Lyon.",
    hero: {
      eyebrow: "Préparer demain",
      title: "Plan d'Épargne Retraite",
      subtitle: "Le PER unifié remplace les anciens dispositifs : épargne dédiée à la retraite, déductible fiscalement, sortie souple en capital ou rente."
    },
    benefits: [
      { title: "Déduction fiscale", text: "Vos versements volontaires sont déductibles de votre revenu imposable, dans la limite des plafonds en vigueur." },
      { title: "Sortie souple", text: "À la retraite, sortez en capital, en rente, ou en mixte selon vos besoins de vie." },
      { title: "Cas de déblocage", text: "Achat de résidence principale, accident de la vie : déblocage anticipé possible." },
      { title: "Transférable", text: "Regroupez vos anciens PERP, Madelin, Article 83 dans un PER unique, plus lisible et performant." }
    ],
    coversTitle: "Atouts du PER",
    covers: [
      "Déduction des versements du revenu imposable",
      "Gestion pilotée par défaut (sécurisation progressive)",
      "Sortie en capital, rente viagère ou mix",
      "Déblocage anticipé pour achat résidence principale",
      "Transmission optimisée en cas de décès avant 70 ans",
      "Possibilité de transférer d'autres contrats retraite"
    ],
    audience: "Salariés, TNS, professions libérales, chefs d'entreprise et particuliers fortement fiscalisés (TMI ≥ 30%) souhaitant préparer leur retraite tout en réduisant leur imposition annuelle.",
    faq: [
      { q: "Quand puis-je récupérer l'argent du PER ?", a: "À l'âge de la retraite (ou liquidation des droits). Avant, déblocage anticipé possible dans certains cas : achat résidence principale, invalidité, décès du conjoint, surendettement, fin de droits chômage." },
      { q: "Quel est l'avantage fiscal exact ?", a: "Vos versements sont déduits de votre revenu imposable. Pour une tranche à 30%, 5 000€ versés = 1 500€ d'impôt en moins. L'économie est encore plus forte pour les tranches à 41% ou 45%." },
      { q: "PER ou assurance vie : que choisir ?", a: "Idéalement les deux. L'assurance vie reste liquide, le PER est dédié à la retraite avec un avantage fiscal à l'entrée. Nous analysons votre situation pour déterminer la bonne articulation." },
      { q: "Que devient le PER en cas de décès ?", a: "Le capital est transmis aux bénéficiaires désignés. La fiscalité dépend de l'âge au décès et du PER choisi (assurantiel ou compte-titres)." }
    ]
  }
];

export const getServiceBySlug = (slug) => SERVICES.find(s => s.slug === slug);
